import { useEffect } from 'react';

import GridTable from 'components/grid-table/grid-table';
import ValidationsIsAny from './summary-is-any/validations-is-any';
import SummaryHeading from './summary-heading';
import useValidationsQuery from 'lib/hooks/use-validations-query';
import { ValidationsDataItem } from 'types';
import { columnsValidations } from 'utils/columns-table';
import { useAppSelector } from 'redux/use-hooks';
import { selectAccountId } from 'redux/slices/account';

import config from 'config';
const { VALIDATION_URL } = config;

import { Row } from 'assets/styles/pages.style';

const SummaryValidationsRow = () => {
  const accountId = useAppSelector(selectAccountId);
  const { data, isLoading, isLoadingMore, hasMore, page, setPage, refetch } = useValidationsQuery<ValidationsDataItem>();

  useEffect(() => {
    (async function () {
      if (accountId) {
        await refetch(accountId, page);
      }
    })();
  }, [accountId, page]);

  return (
    <>
      <SummaryHeading
        href={VALIDATION_URL}
        title="My Validations"
        textBtn="Open Validator Dashboard"
      />
      <Row mb={6}>
        <GridTable<ValidationsDataItem>
          uniqueKey="summary-validation"
          loading={isLoading}
          isLoading={isLoadingMore}
          columns={columnsValidations}
          cols={6}
          componentEmpty={<ValidationsIsAny />}
          hasMore={hasMore}
          setPage={setPage}
          data={data}
        />
      </Row>
    </>
  );
};

export default SummaryValidationsRow;
